module.exports = __webpack_public_path__ + "img/logo-white.9be6c9a4.png";